/* eslint-disable */
import { GET_SINGLE_APPROVAL_DETAILS, GET_SUPERVIOSR_NAME_BY_ID, SET_CHANGE_PWD_MODAL, SET_GET_ACTIVE_USER, SET_GET_APPROVAL_USER, SET_GET_USER_DASHBOARD_COUNT, SET_ROLE_BY_DEPT, SET_ROLE_BY_DEPT_BY_ID, SET_SUPERVISOR_BY_ROLE } from '../../../common/constants/ActionTypes';
import { ADDADMINUSER, ADMIN_CHANGE_PASSWORD, APPROVALUSER, CHANGE_PASSWORD, DELETEUSERREQUEST, GET_ALL_UNAPPROVAL_ENTITY_LIST, GET_SINGLE_APPROVAL_DETAILS_API, GET_SUPERVIOSR_NAME_BY_ID_API, GET_SUPERVISOR_ROLE_API, GET_USER_DASHBOARD_COUNT, GETACTIVEUSER, GETROLES, UPDATEUSERREQUEST } from "../../../common/constants/endpoints";
import API from "../../../helpers/API";
// import { logout } from "../../common/actions/commonActions";
import { toastr } from 'react-redux-toastr';

import { logoutAdmin } from "../../../registration_login/actions/sessionActions";


export const getAllRoles = () => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GETROLES, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ROLE_BY_DEPT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const getSupervisorByDeptAndRoleId = (deptid, roleid) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_SUPERVISOR_ROLE_API + `/${deptid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_SUPERVISOR_BY_ROLE,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const addUser = (newuserDetails, props) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADDADMINUSER, newuserDetails, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // dispatch(getAllApprovalUser());
            dispatch(getAllUser())
            // toastr.success("User added successfully and request sent for the approval");
            let successMessage = (response && response.data) ?
                response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};
export const getAllUser = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETACTIVEUSER, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_ACTIVE_USER,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const getAllApprovalUser = (pageNumber, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let userId = session.userId;
        let response;
        try {
            // response = await API.get(GETAPPROVALUSER + `/${userId}`, {
            //     headers: { Authorization: `Bearer ${token}` },
            // });
            response = await API.get(GET_ALL_UNAPPROVAL_ENTITY_LIST + `/${pageNumber}` + `/${rowPerPage}` + '?entitytypes=oasAdminUser', {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch({
                type: SET_GET_APPROVAL_USER,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const updateRequest = (newuserDetails, props) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;

        try {
            let response;
            response = await API.patch(UPDATEUSERREQUEST, newuserDetails, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllApprovalUser());
            dispatch(getAllUser())
            toastr.success("User updated successfully and request sent for the approval");
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};
export const deleteRequest = (id, props) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;

        try {
            response = await API.patch(DELETEUSERREQUEST + `/${id}`, {}, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            dispatch(getAllApprovalUser());
            dispatch(getAllUser())
            toastr.success("User deleted successfully");
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};
export const approvalUserRequest = (requestBody) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(APPROVALUSER, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllApprovalUser());
            dispatch(getAllUser());
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const setChangePasswordFlg = (flag) => {
    return async (dispatch) => {
        dispatch({
            payload: flag,
            type: SET_CHANGE_PWD_MODAL,
        });
    }
};

export const ChangePasswordRequest = (data, props) => {
    return async (dispatch) => {
        let response;
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            const token = session.jwtResponse && session.jwtResponse.token;
            response = await API.post(CHANGE_PASSWORD, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                payload: false,
                type: SET_CHANGE_PWD_MODAL,
            });
            if (response.status === 200) {
                toastr.success(" Kindly re login using new password")
            }
            if (response.status === 200) {
                toastr.success("Password is updated successfully ")
                // dispatch(logout(props));
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const AdminChangePasswordRequest = (data, props, navigate) => {
    return async (dispatch) => {
        let response;
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            const token = session.jwtResponse && session.jwtResponse.token;
            response = await API.post(ADMIN_CHANGE_PASSWORD, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                payload: false,
                type: SET_CHANGE_PWD_MODAL,
            });

            if (response.status === 200) {
                toastr.success("Password is updated successfully. Kindly re login using new password")
                dispatch(logoutAdmin(props, navigate));
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getUserDashboardCount = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_USER_DASHBOARD_COUNT, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_USER_DASHBOARD_COUNT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}


export const getSingleApprovalDetails = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            const response = await API.get(`${GET_SINGLE_APPROVAL_DETAILS_API}`, {
                params: { id },
                headers: { Authorization: `Bearer ${token}` },
            })
            dispatch({
                type: GET_SINGLE_APPROVAL_DETAILS,
                payload: response.data
            })

        } catch (error) {
            if (error.response && error.response.data) {
                toastr.error("Facing some issue while getting single user approval details", error.response.data.message);
            } else {
                toastr.error("Facing some issue while getting single user approval details", error.message);
                throw new error(error.message);
            }
        }
    }
}



export const editAllApprovalUser = (newuserDetails, props) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;

        try {
            let response;
            response = await API.patch(UPDATEUSERREQUEST, newuserDetails, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllApprovalUser(0, 10));
            dispatch(getAllUser())
            toastr.success("User updated successfully and request sent for the approval");
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};


export const getSupervisorDetailById = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;
        try {
            const response = await API.get(`${GET_SUPERVIOSR_NAME_BY_ID_API}/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            })

            dispatch({
                type: GET_SUPERVIOSR_NAME_BY_ID,
                payload: response.data[0]
            })

        } catch (error) {
            if (error.response && error.response.data) {
                toastr.error("Getting some issue while fetching supervisor details", error.response.data.message);
            } else {
                toastr.error("Getting some issue while fetching supervisor details", error.message);
                throw new error(error.message);
            }
        }
    }
}
export const getRoleDetailById = (id) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GETROLES + "/" + id, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ROLE_BY_DEPT_BY_ID,
                payload: response.data[0],
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}


export const approveUser = (newuserDetails, props) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response;
            response = await API.patch(UPDATEUSERREQUEST, newuserDetails, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toastr.success("User Approval done");
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            toastr.error("Facing some issue while fetching details for review");
            return;
        }
    }
};
